import ApiRoutes from "../../../constants/api-routes";
import { hneInsightApi } from "../../../service";

export const getAllNewsUrls = async () =>
    hneInsightApi.get(`${ApiRoutes.GET_ALL_NEWS_URLS}`);
